import { render, staticRenderFns } from "./DashboardMenuItemDetails.vue?vue&type=template&id=4423229c&scoped=true&"
import script from "./DashboardMenuItemDetails.vue?vue&type=script&lang=ts&"
export * from "./DashboardMenuItemDetails.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardMenuItemDetails.vue?vue&type=style&index=0&id=4423229c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4423229c",
  null
  
)

export default component.exports